import { versionNeedsUpgrade } from '@/helpers/helpers'

const initialState = () => ({
  installations: [],
  loadingInstallations: true,
  latestVersion: '',
})

const state = initialState

const getters = {
  installations: state => state.installations,
  loadingInstallations: state => state.loadingInstallations,
  latestVersion: state => state.latestVersion,
}

const mutations = {
  SET_INSTALLATIONS (state, installations) {
    state.installations = installations.map(inst => ({
      ...inst,
      needsUpdate: versionNeedsUpgrade(inst.ver, state.latestVersion)
    }))
  },
  SET_LOADING_INSTALLATIONS (state, loading) {
    state.loadingInstallations = loading
  },
  SET_LATEST_VERSION (state, ver) {
    state.latestVersion = ver
  },
}

const actions = {
  async getInstallationsList ({ commit, dispatch }, _username) {
    commit('SET_LOADING_INSTALLATIONS', true)
    const data = {
      method: 'wordpress',
      _username,
    }
    const response = await dispatch('softaculous_api', data, { root: true })
    if (!response.wordpressins) {
      commit('SET_LOADING_INSTALLATIONS', false)
      throw new Error('Softaculous API error.')
    }
    commit('SET_INSTALLATIONS', Object.values(response.wordpressins))
    commit('SET_LOADING_INSTALLATIONS', false)
  },
  async getWpInfo ({ commit, dispatch }, _username) {
    const data = {
      method: 'scripts',
      _username,
    }
    const response = await dispatch('softaculous_api', data, { root: true })
    if (!response.iscripts) {
      throw new Error('Unable to load latest version info.')
    }
    const wpVer = Object.entries(response.iscripts).find(script => script[1]?.softname == 'wp')[1]['ver']
    if (wpVer) {
      commit('SET_LATEST_VERSION', wpVer)
    }
  },
  async setStaging ({ dispatch }, payload) {
    const data = {
      method: `staging&insid=${payload.insid}&jsnohf=1&soft=26&multi_ver=1`,
      ...payload,
    }

    const r = await dispatch('softaculous_api', data, { root: true })

    if (r.error) {
      const errors = Object.values(r.error).map(i => i)
      throw new Error(errors)
    }
  },
  async pushToLive ({ dispatch }, payload) {
    const data = {
      method: `pushtolive&insid=${payload.insid}&jsnohf=1`,
      ...payload
    }

    const r = await dispatch('softaculous_api', data, { root: true })

    if (r.error) {
      const errors = Object.values(r.error).map(i => i)
      throw new Error(errors)
    }

    return {
      structural_change_tables: r.tables_structure_diff ?? [],
      datachange_tables: r.tables_data_diff ?? []
    }
  },
  async removeScript ({ dispatch }, payload) {
    const data = {
      method: `remove&insid=${payload.insid}&jsnohf=1`,
      ...payload
    }

    const r = await dispatch('softaculous_api', data, { root: true })

    if (r.error) {
      const errors = Object.values(r.error).map(i => i)
      throw new Error(errors)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
